<template>
    <div id="container" :type="glb.pageType">
        <div class="page page-about" v-ga:page="{pageType: glb.pageType, glb: glb}">
            <mvtHeader />
            <imageHeader :title="title" :subtitle="subtitle" :description="description" :imageType="imageType"/>
            <section class="faq">
                <h2><a class="text-bold f3"  href="http://help.movoto.com/">Frequently Asked Questions </a></h2>
                <mvtFaq v-if="faqQuery" :query="faqQuery" :limit="limit" />
            </section>
            <contact />
        </div>
        <mvtFooter />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import contact from '../common/contact.vue';
import imageHeader from '../common/imageHeader.vue';
import faqConf from '@/common/store/glb/data.faqs';

export default {
    name: 'pageFaqs',
    inject: ['$eventBus'],
    components: {
        mvtFaq,
        mvtDialogCenter,
        mvtHeader,
        mvtFooter,
        contact,
        imageHeader
    },
    data: function() {
        return {
            faqQuery: faqConf.genericFAQs,
            limit: 100,
            imageType: 'none',
            title: 'Movoto Real Estate FAQ',
            subtitle: 'We care about where you live + how you live',
            description: 'Search homes for sale and learn about the local schools, demographics, and market trends. <br /> The most trusted source to help you buy or sell a home on the MLS.'
        }
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getPhoneNumber']),
    },
    methods: {
      showContactForm: function() {
          this.$eventBus.$emit('dialog-open-contactus');
      }
    },
};
</script>
<style lang="scss">
@use './faqs.scss' as *;
</style>